"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cdnSources = void 0;
// 这个文件是不需要这么严苛的eslint规范，屏蔽掉一些没必要的eslint
// eslint-disable-next-line max-len
/* eslint-disable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
/**
 * 将所有的cac整改配置收拢到该文件，将代码里的写死域名之类的也收拢到该文件，在此集中disable相关eslint
 */
/* eslint-disable @tencent/tdoc-standalone/no-use-uri-like-literal */
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
var appConfigInstance = docs_config_1.default.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/netcheck"]');
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
exports.cdnSources = Object.values((npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.cdnSources) || [
    'https://docs.qq.com/net-check/img',
    'https://docs.gtimg.com/components/img/1px.gif',
    'https://docs2.gtimg.com/components/img/1px.gif',
]);
//# sourceMappingURL=index.js.map